<template>
    <b-row>
        <b-col cols="6">
            <b-form-select
                value-field="id"
                text-field="name"
                v-model="order_item_type_id"
                required
                :options="types"
                :disabled="disabled"
            >
                <template #first>
                    <b-form-select-option :value="null" disabled
                        >Select Item Type</b-form-select-option
                    >
                </template>
            </b-form-select>
        </b-col>
        <b-col cols="6">
            <vue-typeahead-bootstrap
                v-model="searchedMasterItem"
                :data="masterItems"
                :serializer="s => s.name"
                @hit="getMasterItem"
                @input="lookupMasterItems"
                placeholder="Search Master Items..."
                :disabled="disabled"
            />
        </b-col>
    </b-row>
</template>
<script>
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'

import { debounce } from 'lodash'
export default {
    components: { VueTypeaheadBootstrap },
    props: ['value', 'disabled', 'type'],
    data: () => ({
        searchedMasterItem: '',
        order_item_type_id: null,
    }),
    computed: {
        masterItems() {
            return this.$store.state.masterItem.items
        },
        masterItem() {
            return this.$store.state.masterItem.item
        },
        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        type: function (_type) {
            this.order_item_type_id = _type
        },
        searchedMasterItem: function (to, from) {
            if (from && to === '') {
                this.$emit('input', null)
                this.$emit('set-master-item', null)
            }
        },
        value: async function (id) {
            await this.setValue(id)
        },
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
    },
    async mounted() {
        this.order_item_type_id = this.type
        await this.setValue(this.value)
    },
    methods: {
        async setValue(id) {
            if (id) {
                try {
                    await this.$store.dispatch('masterItem/fetchById', id)
                    await this.$nextTick()
                    this.searchedMasterItem = this.masterItem.name
                } catch (err) {
                    console.log('err', err)
                }
            }
        },
        getMasterItem(masterItem) {
            console.log('masterItem---', masterItem)
            this.$emit('input', masterItem.id)
            this.$emit('set-master-item', masterItem)
        },
        lookupMasterItems: debounce(function () {
            // in practice this action should be debounced
            const { searchedMasterItem: query, order_item_type_id } = this
            const filters = { order_item_type_id }
            const page = 1
            this.$store.dispatch('masterItem/fetch', { page, query, filters })
        }, 500),
    },
}
</script>